import { Card } from 'components/Card';
import { InputColorPicker } from 'components/InputColorPicker';
import { InputFormField } from 'components/InputFormField';
import { InputImage } from 'components/InputImage';
import default_avatar from 'assets/imgs/img_sellers_identity/default_avatar.png'
import React from 'react';

import { 
  Container,
  Content,
  ImageDetails,
  PreviewBackgound,
  ImagePreview,
  ExternalLink,
  CardContent,
  LogoCard,
  SellerNickname
} from './styles';
import { useIdentity } from './useIdentity';
import { Title } from 'components/Title';
import { Button } from 'components/Button';
import { Footer } from 'components/Footer';
import { Badge } from 'components/Badge';
import { Loading } from 'components/Loading';
import { PlaceHolderNotExists } from 'components/PlaceholderNotExists';

export const Identity: React.FC = () => {
  const {
    loading,
    hasError,
    imagePath,
    inputsValues,
    changedFields,
    touched,
    errors,
    imageSelectedHandler,
    handleChange,
    textColor,
    translatedFields,
    handleFormSubmit,
    handleFormDiscard,
    logoIsPNG
  } = useIdentity();
  
  if (loading) {
    return <Loading/>

  }

  if (hasError) {
    return (
      <PlaceHolderNotExists title="Erro ao tentar conectar com o servidor" />
    )
  }

  return (
    <Container>
      <Content>
        <Card title="Logo">
          <LogoCard>
            <ImagePreview
              imageUrl={imagePath ?? inputsValues.logo ?? default_avatar}
              width={156}
              height={156}
            />
            <ImageDetails>
              Sempre que possível utilize um arquivo de proporção 1:1
              <InputImage
                error={touched.logo && !!errors.logo}
                errorMessage='Nenhuma imagem encontrada'
                errorByTypeImage={!logoIsPNG && !!imagePath}
                errorMessageByTypeImage="Por favor, utilize arquivos em .PNG"
                onChange={imageSelectedHandler}
              />
            </ImageDetails>
          </LogoCard>
        </Card>

        <Card title="Display">
          <CardContent>
            <InputFormField
              name="nickname"
              label="Nome display"
              type="text"
              value={inputsValues.nickname}
              error={touched.nickname && !!errors.nickname}
              mensageError='Nome inválido'
              onChange={handleChange}
              block={true}
            />

            <InputColorPicker
              name="primaryColor"
              label="Cor primária"
              value={inputsValues.primaryColor}
              error={touched.primaryColor && !!errors.primaryColor}
              errorMessage='Cor inválida'
              onChange={handleChange}
              block={true}
            />
          </CardContent>
        </Card>
      </Content>

      <Content>
        <Card title="Preview">
          <PreviewBackgound
            color={inputsValues.primaryColor}
          >
            <ImagePreview
              imageUrl={imagePath ?? inputsValues.logo ?? default_avatar}
            />
            <SellerNickname
              textColor={textColor()}
            >
              {inputsValues.nickname}
            </SellerNickname>
            <ExternalLink>
              meusite.com.br
            </ExternalLink>
          </PreviewBackgound>
        </Card>
      </Content>
      <Footer>
        <Title elementHTML="strong" text="Campos atualizados:" className="tag" />

        {changedFields.map((item: string) => (item ? <Badge value={translatedFields(item) ?? ''} key={item} /> : null))}
        
        <Button type="button" label="Descartar" size="medium" typeBtn="outline" onClick={handleFormDiscard} />
        <Button type="button" label="Atualizar dados" size="medium" typeBtn="blue" onClick={handleFormSubmit} />

      </Footer>
    </Container>
  );
}
